import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { AmplifyGrid, AmplifyGridRow } from '@amplify/amplify-grid';
import Spinner from '../../../../components/spinner/Spinner';
import { SECTION_IDS, GRID } from '../../../../constants/shared/CommonConstants';
import { CELL_MEASUREMENTS } from '../../../../constants/shared/CellConstants';
import { getRowsToRender } from './benchmarkHistoryHelper';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const SS_CELL_STYLE = { borderTopColor: '#fff' };
const SS_SUBHEADER_STYLE = { lineHeight: '0' };
const { SS_BH } = SECTION_IDS;

const StudentSummaryTable = ({
    infoBox,
    location,
    gradeToMeasureMapper,
    openProbeDetails,
    CommonCellBuilder,
    benchmarkHistoryData,
    isGradeYearsFetching,
}) => {
    if (isGradeYearsFetching) return <Spinner />;

    const { rows, colSpans } = getRowsToRender(
        benchmarkHistoryData,
        openProbeDetails,
        CommonCellBuilder,
        location,
        gradeToMeasureMapper,
    );
    return useMemo(
        () => (
            <div id={SS_BH} className="data-area">
                {infoBox}
                <div className="grid-container-wrapper">
                    <AmplifyGrid
                        colSpans={colSpans}
                        dataCellStyles={SS_CELL_STYLE}
                        subHeaderStyles={SS_SUBHEADER_STYLE}
                        areSubHeadersSticky
                        scrollMode={GRID.SCROLL_MODE.CONTAINER}
                        defaultCellMeasurements={CELL_MEASUREMENTS.DEFAULT}
                    >
                        {rows.map((row, index) => (
                            <AmplifyGridRow
                                key={generateReactKey(index)}
                                rowObject={row.rowObject}
                                isGridHeader={row.isGridHeader}
                            />
                        ))}
                    </AmplifyGrid>
                </div>
            </div>
        ),
        [isGradeYearsFetching],
    );
};

StudentSummaryTable.defaultProps = {
    isGradeYearsFetching: false,
    location: {},
    gradeToMeasureMapper: [],
    infoBox: <></>,
    openProbeDetails: () => <></>,
    CommonCellBuilder: () => <></>,
};

StudentSummaryTable.propTypes = {
    isGradeYearsFetching: PropTypes.bool,
    infoBox: PropTypes.element,
    gradeToMeasureMapper: PropTypes.array,
    location: PropTypes.object,
    benchmarkHistoryData: PropTypes.object.isRequired,
    openProbeDetails: PropTypes.func,
    CommonCellBuilder: PropTypes.func,
};

export default StudentSummaryTable;
